import { getDistance } from './geo/get-distance.js';

/**
 * Find each `item`'s geodesic distance to the `reference` (in meters). Returns
 * an array of `[item, distance]` tuples, sorted by distance.
 */ const sortByDistance = (reference, items)=>items.map((item)=>[
            item,
            getDistance(reference, item)
        ]
    ).sort((a, b)=>a[1] - b[1]
    )
;

export { sortByDistance };
//# sourceMappingURL=sort-by-distance.js.map
